/*
 * product-description-clamp.js
 * Mobile-only "Lees meer / Lees minder" toggle voor .product__description.
 * Wordt geladen via snippets/head.liquid.
 *
 * Werkt samen met assets/custom.css (.is-clamped class).
 */
(function () {
  'use strict';

  var MQ = '(max-width: 749px)';

  function init() {
    if (!window.matchMedia(MQ).matches) return;

    document.querySelectorAll('.product__description').forEach(function (wrap) {
      if (wrap.dataset.clampReady === '1') return;

      var text = wrap.querySelector('.product__description__text');
      var btn = wrap.querySelector('.product__description__toggle');
      if (!text || !btn) return;

      wrap.dataset.clampReady = '1';

      function check() {
        wrap.classList.add('is-clamped');
        var overflows = text.scrollHeight > text.clientHeight + 1;
        btn.hidden = !overflows;
        if (!overflows) wrap.classList.remove('is-clamped');
      }

      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        wrap.classList.toggle('is-clamped', expanded);
        btn.textContent = expanded ? 'Lees meer' : 'Lees minder';
      });

      check();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-check op resize (orientatie / viewport change)
  var rafId = null;
  window.addEventListener('resize', function () {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(function () {
      document.querySelectorAll('.product__description[data-clamp-ready="1"]').forEach(function (wrap) {
        var text = wrap.querySelector('.product__description__text');
        var btn = wrap.querySelector('.product__description__toggle');
        if (!text || !btn) return;

        // Reset naar clamped state
        wrap.classList.add('is-clamped');
        btn.setAttribute('aria-expanded', 'false');
        btn.textContent = 'Lees meer';

        var overflows = text.scrollHeight > text.clientHeight + 1;
        btn.hidden = !overflows;
        if (!overflows) wrap.classList.remove('is-clamped');
      });
    });
  });
})();
